import Axios from 'axios'

import { PatchGroupMemberBody, GroupMember } from 'types/GlobalGroup'

import { parseAuthenticationHeader } from 'helpers/Functions'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/group-members`

export async function update(id: string, body: PatchGroupMemberBody) {
  return Axios.patch<{ data: GroupMember }>(
    `${URL}/${id}`,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
